/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/accordion/accordion.ts" />
/// <reference path="../../common/common/common.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/forms/forms.ts" />
/// <reference path="../../common/resources/resources.ts" />
/// <reference path="../../crm/entitypicker/entitypicker.ts" />
/// <reference path="../../crm/entitieslist/entitieslist.ts" />

namespace OfficeGuy.Apps {
    export class Accounting {
        static PricesIncludeVAT = false;
        static SelectedCustomer_Bank = "";
        static SelectedCustomer_Branch = "";
        static SelectedCustomer_Account = "";
        static SelectedCustomer_NoVAT = false;
        static SelectedCustomer_LastDigits = "";
        static DiscountElementID = 0;
        static RoundingElementID = 0;
        static Rounding = 0;
        static IsExpense = false;
        static IsCredit = false;
        static IsBilling = false;
        static ShowDescriptions;
        static PaymentsTemplates;
        static PaymentsTemplatesTicks;

        static Init(): void {
            Accounting.BindEvents_Init();
        }

        static PageLoad(IsExpense, IsCredit, IsBilling): void {
            Accounting.SelectedCustomer_Bank = "";
            Accounting.SelectedCustomer_Branch = "";
            Accounting.SelectedCustomer_Account = "";
            Accounting.SelectedCustomer_NoVAT = false;
            Accounting.SelectedCustomer_LastDigits = "";
            Accounting.IsExpense = IsExpense;
            Accounting.IsCredit = IsCredit;
            Accounting.IsBilling = IsBilling;
            Accounting.RefreshForeignCurrency();
            Accounting.RefreshPaymentsPlaceholder();
            Accounting.RemoveUnusedValues();
            Accounting.BindEvents_PageLoad();
        }

        static BindEvents_Init(): void {
            $(document.body).on("input.accounting-values", ".documentitem .og-accounting-items-quantity, .documentitem .og-accounting-items-unitcompanyvalue, .documentitem .og-accounting-items-unitdocumentvalue, .documentitem .og-accounting-items-companyvalue, .documentitem .og-accounting-items-documentvalue, .documentitem .og-accounting-items-multiplevat", function () {
                Accounting.RefreshQuantities();
                var $Input = $(this);
                var $Row = $Input.closest('tr');
                Accounting.RoundElementTwoPoints($("input", this));

                var $Quantity = $(".og-accounting-items-quantity input", $Row);
                var QuantityValue = $Quantity.length == 0 || (<string>$Quantity.val()).length == 0 ? "1" : <string>$Quantity.val();
                var $UnitCompanyValue = $(".og-accounting-items-unitcompanyvalue input", $Row);
                var $CompanyValue = $(".og-accounting-items-companyvalue input", $Row);
                var $UnitDocumentValue = $(".og-accounting-items-unitdocumentvalue input", $Row);
                var $DocumentValue = $(".og-accounting-items-documentvalue input", $Row);
                var $MultipleVAT = $(".og-accounting-items-multiplevat input", $Row);
                var MultipleVATValue = $MultipleVAT.length == 0 ? 0 : Number($MultipleVAT.val());
                var VATIncluded = $(".og-accounting-vatincluded input:hidden:last").val() == "True";

                if ($Input.is(".og-accounting-items-unitcompanyvalue, .og-accounting-items-companyvalue")) {
                    if ($("input", this).val() != "")
                        $(".og-accounting-items-unitdocumentvalue input, .og-accounting-items-documentvalue input", $Row).val(null);
                    if ($Input.val() && !Accounting.IsNumber($("input", this).val()))
                        $(".og-accounting-items-unitcompanyvalue input, .og-accounting-items-companyvalue input", $Row).val(null);
                }
                if ($Input.is(".og-accounting-items-unitdocumentvalue, .og-accounting-items-documentvalue")) {
                    if ($("input", this).val() != "")
                        $(".og-accounting-items-unitcompanyvalue input, .og-accounting-items-companyvalue input", $Row).val(null);
                    if ($Input.val() && !Accounting.IsNumber($("input", this).val()))
                        $(".og-accounting-items-unitdocumentvalue input, .og-accounting-items-documentvalue input", $Row).val(null);
                }
                if (Accounting.IsNumber(QuantityValue)) {
                    if ($Input.is(".og-accounting-items-quantity, .og-accounting-items-unitcompanyvalue, .og-accounting-items-unitdocumentvalue, .og-accounting-items-multiplevat")) {
                        if (Accounting.IsNumber($UnitCompanyValue.val()))
                            $CompanyValue.val(Common.RoundTwoPoints(Number($UnitCompanyValue.val()) * Number(QuantityValue) + (VATIncluded ? MultipleVATValue : 0)).toString());

                        if ($UnitDocumentValue.length > 0 && Accounting.IsNumber($UnitDocumentValue.val()))
                            $DocumentValue.val(Common.RoundTwoPoints(Number($UnitDocumentValue.val()) * Number(QuantityValue) + (VATIncluded ? MultipleVATValue : 0)).toString());
                    }
                    else if ($Input.is(".og-accounting-items-companyvalue, .og-accounting-items-documentvalue")) {
                        if (Accounting.IsNumber($CompanyValue.val()))
                            $UnitCompanyValue.val(Common.RoundTwoPoints((Number($CompanyValue.val()) - (VATIncluded ? MultipleVATValue : 0)) / Number(QuantityValue)).toString());

                        if ($DocumentValue.length > 0 && Accounting.IsNumber($DocumentValue.val()))
                            $UnitDocumentValue.val(Common.RoundTwoPoints((Number($DocumentValue.val()) - (VATIncluded ? MultipleVATValue : 0)) / Number(QuantityValue)).toString());
                    }
                }
                Accounting.CalculateItemTotals();
                if (Accounting.IsCredit && (Number(QuantityValue) < 0 || Number($UnitCompanyValue.val()) < 0 || Number($UnitDocumentValue.val()) < 0) && !$Row.closest('table').data("NegativeWarningShown")) {
                    Modals.ShowMessageDialog('מסמך זיכוי', 'המערכת זיהתה שהזנת מספר שלילי (מינוס).<br />מסמך זיכוי הינו מסמך מזכה בסכום שנקוב פה, ולכן צריך להקליד סכום בפלוס כדי שהמערכת תתייחס לפעולה כפעולה במינוס.<br /><br />במקרים נדירים, למשל כדי לבטל מסמך זיכוי, ניתן להפיק מסמך זיכוי בסכום שלילי.', 'הבנתי');
                    $Row.closest('table').data("NegativeWarningShown", "1");
                }
            });
            $(document.body).on("input.accounting-discount", ".documentitemsfooter #og-accounting-items-discountcompanyvalue, .documentitemsfooter #og-accounting-items-discountdocumentvalue", function () {
                if ($(this).is("#og-accounting-items-discountcompanyvalue, #og-accounting-items-discountdocumentvalue")) {
                    if (!Accounting.IsNumber($(this).val()))
                        $(this).val(null);
                }

                Accounting.RoundElementTwoPoints($(this));
                Accounting.CalculateItemTotals();
            });

            $(document.body).on("input.accounting-payment", ".payment .og-accounting-payments-companyvalue, .payment .og-accounting-payments-documentvalue", function () {
                var $ParentRow = $(this).closest('tr');
                if ($(this).is(".og-accounting-payments-companyvalue")) {
                    if ($("input", this).val() != "")
                        $(".og-accounting-payments-documentvalue input", $ParentRow).val(null);
                }
                else if ($(this).is(".og-accounting-payments-documentvalue")) {
                    if ($("input", this).val() != "")
                        $(".og-accounting-payments-companyvalue input", $ParentRow).val(null);
                }

                Accounting.CalculatePaymentTotals();
            });
            $(document.body).on("change.accounting-duedateinput", "form .duedate input.datepicker", function () {
                var $this = $(this);
                var Value = $this.val();
                Teva.SelectBox.GetInstance($(".duedate .entitypicker")).ClearValue();
                $this.val(Value);
            });
        }
        static ShowExpenseDateWarning($DateElement, Value) {
            var Minimum = new Date();
            Minimum.setMonth(Minimum.getMonth() - 5);
            Minimum.setDate(0);

            $DateElement.closest(".sumit-field-value").find(".og-expenses-quick-date-notification").remove();

            if (Value >= Minimum)
                return;

            var CurrentDate = new Date();

            if ((CurrentDate.getFullYear() * 12 + CurrentDate.getMonth()) - (Value.getFullYear() * 12 + Value.getMonth()) > 5) {
                $DateElement
                    .closest(".sumit-field-value")
                    .append($
                        (document.createElement('div')
                            .addClass("sumit-field-display-error", "og-expenses-quick-date-notification"))
                        .html("הוצאה ישנה!")
                    );
            }
        }
        static BindEvents_PageLoad(): void {
            var IsPageLoadEvent = true;
            $(".og-accounting-date input.datepicker").on("change.accounting-date", function () {
                var $Input = $(this);
                $Input.trigger("change.datepicker");
                var Value = Teva.DatePicker.GetDateFromString(<string>$Input.val(), Teva.DatePickerMode.Date);
                if (Value == null || Value.getFullYear() < 1900)
                    return;

                var DocumentDefinition = $(".document-definition input").val();
                if (Accounting.IsExpense) {
                    $Input.closest(".sumit-field-value").find(".og-expenses-quick-date-notification").remove();
                    DocumentDefinition = $(".document-definition input").val();
                    if (DocumentDefinition == '13' || DocumentDefinition == '14')
                        Accounting.ShowExpenseDateWarning($Input, Value);
                }
                else if (DocumentDefinition == '2' || DocumentDefinition == '3' || DocumentDefinition == '6' || DocumentDefinition == '7' || DocumentDefinition == '8' || DocumentDefinition == '10' || DocumentDefinition == '11' || DocumentDefinition == '12' || DocumentDefinition == '40' || DocumentDefinition == '41') {
                    const Today = new Date();
                    Today.setHours(0, 0, 0, 0);
                    $Input.closest(".sumit-field-value").find(".sumit-field-display-error").remove();
                    if (Value.valueOf() != Today.valueOf()) {
                        $Input
                            .closest(".sumit-field-value")
                            .append($
                                (document.createElement('div')
                                    .addClass("sumit-field-display-error"))
                                .html("זה באמת התאריך שהתכוונת אליו?")
                            );
                    }
                }


                var Range_From = new Date();
                Range_From.setMonth(Range_From.getMonth() - 2);
                var Range_To = new Date()
                Range_To.setMonth(Range_To.getMonth() + 2);
                if ((!Accounting.IsExpense && Value < Range_From) || Value > Range_To)
                    OfficeGuy.Modals.ShowMessageDialog("תאריך המסמך", "לתשומת הלב, המערכת שמה לב שהוזן תאריך שעשוי להיות שגוי. התאריך שהוזן הינו " + $Input.val() + ".");

                if ($(".duedate .entitypicker").length > 0 && (!IsPageLoadEvent || $(".duedate input.datepicker").length == 0))
                    Accounting.AccountingTermsSelected($(".duedate .entitypicker"));

            }).trigger("change.accounting-date");
            $(".og-accounting-currency input.currencypicker, .og-accounting-currencysettings-currency input.currencypicker")
                .on("change.accounting-currency", function () {
                    var IsCurrencySettings = $('.og-accounting-currencysettings-currency').is(":visible");
                    if (!IsCurrencySettings && Accounting.IsExpense && $(".og-accounting-vatrate input:hidden").length != 0 && $(".og-accounting-vatrate input:hidden:last").val() != "0" && $(".og-accounting-currency input.currencypicker").val() != "1") {
                        OfficeGuy.Modals.ShowMessageDialog("אחוז מע\"מ", "לתשומת הלב, באופן עקרוני לא ניתן להזדכות על מע\"מ ששולם במדינה אחרת. לרוב הוצאות מט\"ח מסמנות הוצאה שבוצעה במדינה אחרת. <br />באופן אוטומטי המערכת מעדכנת את אחוז המע\"מ במסמך הוצאה במט\"ח לאפס. <br />במידה וברצונך להכיר במע\"מ במסמך זה, יש להגדיר את אחוז המע\"מ הרצוי ידנית.");
                        Teva.SelectBox.GetInstance($(".og-accounting-vatrate input:hidden")).SetValue("0", "0%");
                    }

                    if (IsCurrencySettings)
                        Teva.SelectBox.GetInstance($(".og-accounting-currency input.currencypicker")).SetValueFromQueryMethod($(this).val());
                    else if ($(".og-accounting-currencysettings-currency input.currencypicker").length > 0)
                        Teva.SelectBox.GetInstance($(".og-accounting-currencysettings-currency input.currencypicker")).SetValueFromQueryMethod($(this).val());

                    $(".og-accounting-currencysettings-exchangerate input").val("");
                    $(".og-accounting-currencysettings-customexchangerate input").val("False");

                    var SelectedCurrency = $(this).val();
                    $(".og-accounting-currencysettings-exchangerate").toggle(SelectedCurrency != "1");
                    $(".og-accounting-currencysettings-foreigncurrencyinput").toggle(SelectedCurrency != "1");
                    if (SelectedCurrency == "1" || Accounting.IsBilling)
                        $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked", SelectedCurrency != "1");
                    else {
                        $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked", true);
                        if (!IsCurrencySettings)
                            Accounting.ShowCurrencySettings();
                    }

                    Accounting.ToggleForeignCurrency(SelectedCurrency != "1");
                    Accounting.MoveValuesBetweenCurrencies();
                    Accounting.RemoveUnusedValues();
                    Accounting.CalculateItemTotals();
                    Accounting.CalculatePaymentTotals();
                });
            $(".og-accounting-vatincluded input:hidden, .og-accounting-vatrate input:hidden:last").on("change.accounting-vat", function () {
                var VATIncluded = $(".og-accounting-vatincluded input:hidden:last").val();
                $(".og-accounting-document-settingsmenu-vatincluded").text(VATIncluded == 'True' ? 'אחרי מע"מ' : 'לפני מע"מ');
                if ($(".og-accounting-items-quantity").length != 0)
                    $(".og-accounting-items-quantity").trigger("input");
                else
                    Accounting.CalculateItemTotals();
                Accounting.RefreshItemsUnitPricePlaceholder();
                $(".og-accounting-vatincludedtoggle").find('input[value=' + VATIncluded + ']').prop('checked', true).trigger('change');
            });
            IsPageLoadEvent = false;
        }
        static RefreshItemsUnitPricePlaceholder() {
            var $VATIncluded = $(".og-accounting-vatincluded input:hidden:last");
            if ($VATIncluded.length == 0)
                return;

            $(".og-accounting-items-unitcompanyvalue input").attr("placeholder", $VATIncluded.val() == 'True' ? "כולל מע\"מ" : "לפני מע\"מ");
        }
        static VATIncludedToggleChanged() {
            var PreviousValue = $(".og-accounting-vatincluded input:hidden").val();
            var NewValue = $(".og-accounting-vatincludedtoggle input:checked").val();
            if (PreviousValue != NewValue)
                $(".og-accounting-vatincluded input:hidden").val(NewValue).trigger("change");
        }

        static CreateNegativeDocument(ID, SchemaID, ShowWarning: boolean = false, IsCredit: boolean = false): boolean {
            if (ShowWarning) {
                var $Modal = Modals.ShowConfirmDialog({
                    Title: "הפקת מסמך מקושר",
                    Message: "לתשומת הלב, מתוך המסמך הנוכחי נוצר מסמך בעבר.<br />האם ברצונך להמשיך וליצור מסמך מקושר נוסף?",
                    ConfirmText: "המשך ליצירה",
                    ConfirmEvent: function () {
                        Modals.Hide($Modal);
                        Accounting.CreateNegativeDocument(ID, SchemaID, false, IsCredit);
                        return false;
                    }
                });
                return false;
            }

            if (IsCredit)
                Modals.ShowURLModal('/accounting/creditdocument/?id=' + ID);
            else
                Navigation.Redirect("/f" + SchemaID + "/new/?OriginalDocument=" + ID);
            return false;
        }

        static ShowIncomeTaxCreditForDonationModal() {
            Modals.Create({
                Title: "קבלת תרומות לפי סעיף 46",
                Body: 'האם העסק מאושר כמוסד ציבור לעניין תרומות לפי סעיף 46?<br /><br />במידה והעסק מוכר לפי סעיף 46, יש לענות "כן" על מנת שעל קבלות התרומה יופיע הכיתוב "למוסד אישור מס הכנסה לעניין תרומות לפי סעיף 46 לפקודת מס הכנסה". אחרת ענו "לא".<br />ניתן תמיד לשנות את הגדרה זו תחת הגדרות ניהול הכנסות.',
                Buttons: [
                    $(document.createElement('button')
                        .attr("type", "button")
                        .addClass("og-button-ui-action", "og-button-color-default")
                        .setText("כן"))
                        .on("click", function () {
                            Common.AjaxRequest({
                                URL: "/accounting/setincometaxcreditfordonation/",
                                ShowLoading: true,
                                Data: { Value: true }
                            });
                            return true;
                        }),
                    $(document.createElement('button')
                        .attr("type", "button")
                        .addClass("og-button-ui-action", "og-button-color-default")
                        .setText("לא")
                    )
                        .on("click", function () {
                            Common.AjaxRequest({
                                URL: "/accounting/setincometaxcreditfordonation/",
                                ShowLoading: true,
                                Data: { Value: false }
                            });
                            return true;
                        })
                ]
            });
        }

        static DownloadPDF(ID, Original): boolean {
            Modals.HideAll();
            OfficeGuy.Navigation.DownloadAsyncAddCookieIdentifier("/accounting/printpdf/?id=" + ID + "&original=" + Original + "&companyid=" + Common.LoggedCompanyID);
            return false;
        }

        static PrintDocument(ID, Original): boolean {
            Modals.HideAll();
            var MobileApplication = Teva.Storage.Cookie_Get("X-OG-Mobile");
            if (MobileApplication == "Android" || MobileApplication == "iPhone") {
                console.log("OG_DownloadPrint:" + Common.FullRootURL + "/accounting/printpdf/?id=" + ID + "&original=" + Original + "&isprint=true");
                return false;
            }
            else
                window.open("/accounting/showpdf/?id=" + ID + "&original=" + Original + "&print=true");
            return false;
        }

        static DownloadPDFs(Original): boolean {
            OfficeGuy.Navigation.DownloadAsyncAddCookieIdentifier("/accounting/printpdf/?id=" + CRM.EntitiesList.SelectedEntities_GetSelected() + "&original=" + Original + "&companyid=" + Common.LoggedCompanyID);
            return false;
        }
        static CloneItem($Link: JQuery) {
            var $Row = $Link.closest("tr").clone();
            //$Row.find("td:last input[name$=EntityID]").val("0");
            //$("td.crm-entities-entity-name", $Row).empty();
            $(".teva-selectbox", $Row).remove();

            var CloneNamePrefix = $Link.closest("tbody").data("clonenameprefix");
            var CloneIDPrefix = $Link.closest("tbody").data("cloneidprefix");
            var PreviousNamePrefix, PreviousIDPrefix, NewNamePrefix, NewIDPrefix;
            var NewIndex = $Link.closest("tbody").children().length;
            NewNamePrefix = CloneNamePrefix + "[" + NewIndex + "]";
            NewIDPrefix = CloneIDPrefix + "_" + NewIndex + "_";

            $Link.closest("tbody").append($Row);

            $Row.find("input, select, textarea").each(function () {
                if ($(this).attr("name") && $(this).attr("name").indexOf(CloneNamePrefix) == 0) {
                    if (PreviousNamePrefix == null)
                        PreviousNamePrefix = $(this).attr("name").substring(0, $(this).attr("name").indexOf(']') + 1);
                    $(this).attr("name", NewNamePrefix + $(this).attr("name").substring(PreviousNamePrefix.length));
                }
                if ($(this).attr("id") && $(this).attr("id").indexOf(CloneIDPrefix) == 0) {
                    if (PreviousIDPrefix == null) {
                        PreviousIDPrefix = $(this).attr("id").substring(0, $(this).attr("id").indexOf('_', CloneIDPrefix.length + 1) + 1);
                    }
                    $(this).attr("id", NewIDPrefix + $(this).attr("id").substring(PreviousIDPrefix.length));
                }
            });

            OfficeGuy.Common.InitEditors($Row);

            Accounting.CalculateItemTotals();
            Teva.Positioning.ScrollToElement($Row);
            return false;
        }
        static RemoveIncomeItem($Element: JQuery) {
            OfficeGuy.Forms.NestedForm_Remove('.items', 'Data.IncomeItems', $Element.closest('tr').index());
            var $PreviousRow = $Element.closest('tr').prev();
            $Element.closest('tr').remove();
            if ($(".items").children().length == 0)
                $('.documentitemsfooter .table-basic-add-item').trigger('click');

            Accounting.CalculateItemTotals();
            if ($PreviousRow.length > 0)
                Teva.Positioning.ScrollToElement($PreviousRow);
            return false;
        }
        static RemoveExpenseItem($Element: JQuery) {
            OfficeGuy.Forms.NestedForm_Remove('.items', 'Data.ExpenseItems', $Element.closest('tr').index());
            var $PreviousRow = $Element.closest('tr').prev();
            $Element.closest('tr').remove();
            if ($("tbody.items").children().length == 0)
                $('.documentitemsfooter .table-basic-add-item').trigger('click');

            Accounting.CalculateItemTotals();
            if ($PreviousRow.length > 0)
                Teva.Positioning.ScrollToElement($PreviousRow);
            return false;
        }
        static RemoveBankLine($Element: JQuery) {
            OfficeGuy.Forms.NestedForm_Remove('.bankpagelines', 'Data.BankPageLines', $Element.closest('tr').index());
            var $PreviousRow = $Element.closest('tr').prev();
            $Element.closest('tr').remove();
            if ($PreviousRow.length > 0)
                Teva.Positioning.ScrollToElement($PreviousRow);
            return false;
        }
        static RemovePayment($Element: JQuery) {
            OfficeGuy.Forms.NestedForm_Remove('tbody.payments', 'Data.Payments', $Element.closest('tr').index());
            var $ElementToFocus = $Element.closest('tr').prev();
            if ($ElementToFocus.length == 0)
                $ElementToFocus = $Element.closest('table');
            if ($("tbody.payments").children().length == 1) {
                var Method = $("tbody.payments .og-accounting-payments-paymentmethod input:hidden").val();
                $Element.closest('tr').remove();
                Accounting.Payments_Add(Method);
            }
            else
                $Element.closest('tr').remove();

            Accounting.CalculatePaymentTotals();
            Accounting.RefreshPaymentsPlaceholder();
            Teva.Positioning.ScrollToElement($ElementToFocus);
            return false;
        }

        static ItemSelected($EntityPicker): void {
            var DocumentItem = $EntityPicker.closest(".documentitem");
            if (DocumentItem.length == 0)
                return;

            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            if (SelectBox.ChangeEventFromInit) {
                if ((DocumentItem.find(".og-accounting-items-unitdocumentvalue input").val() != null && DocumentItem.find(".og-accounting-items-unitdocumentvalue input").val() != "")
                    || DocumentItem.find(".og-accounting-items-unitcompanyvalue input").val() != "")
                    return;
            }
            var Data = SelectBox.SelectedData
            var DocumentValue = "", CompanyValue = "";
            var ItemPrice = null;
            if (Data && Data.AdditionalFields && Data.AdditionalFields["Accounting.IncomeItems.Price"])
                ItemPrice = Data.AdditionalFields["Accounting.IncomeItems.Price"];
            else if (Data && Data.AdditionalFields && Data.AdditionalFields["Accounting.IncomeItems.Cost"])
                ItemPrice = Data.AdditionalFields["Accounting.IncomeItems.Cost"];
            if (ItemPrice) {
                if (!Data.AdditionalFields || !Data.AdditionalFields["Accounting.IncomeItems.CurrencyEnum"] || Data.AdditionalFields["Accounting.IncomeItems.CurrencyEnum"] == 1)
                    CompanyValue = ItemPrice;
                else if (Data.AdditionalFields["Accounting.IncomeItems.CurrencyEnum"] == $('.og-accounting-currency input.currencypicker').val())
                    DocumentValue = ItemPrice;
                if (Accounting.PricesIncludeVAT && Accounting.SelectedCustomer_NoVAT) {
                    var VATRate = Number($(".og-accounting-vatrate input:hidden").data("originalvalue"));
                    if (CompanyValue != "")
                        CompanyValue = Common.RoundTwoPoints(Number(CompanyValue) / (1 + VATRate / 100)).toString();
                    if (DocumentValue != "")
                        DocumentValue = Common.RoundTwoPoints(Number(DocumentValue) / (1 + VATRate / 100)).toString();
                }
                DocumentItem.find(".og-accounting-items-unitdocumentvalue input").val(DocumentValue).trigger("input");
                DocumentItem.find(".og-accounting-items-unitcompanyvalue input").val(CompanyValue).trigger("input");
            }
            if (Data && Data.AdditionalFields != null && Data.AdditionalFields["Accounting.IncomeItems.Description"] && Data.AdditionalFields["Accounting.IncomeItems.Description"] != "")
                DocumentItem.find(".og-accounting-items-description textarea").val(Data.AdditionalFields["Accounting.IncomeItems.Description"]).trigger("change");
        }

        static QuickCreateDocument_ItemSelected($EntityPicker): void {
            var Form = $EntityPicker.closest("form");
            if (Form.length == 0)
                return;

            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);

            var Data = SelectBox.SelectedData
            if (Data && Data.AdditionalFields && Data.AdditionalFields["Accounting.IncomeItems.Price"]) {
                var ItemPrice = Data.AdditionalFields["Accounting.IncomeItems.Price"];
                Form.find(".og-accounting-quickcreatedocument-totalwithvat input").val(ItemPrice).trigger("change");
            }
        }

        static QuickCreateDocument_DocumentDefinitionSelected(): void {
            $(".og-accounting-quickcreatedocument-documentdefinition input").on("change", function () {
                var DocumentDefinition = $(this).val();
                if (DocumentDefinition != '8') {
                    Teva.SlideOrFade.Toggle($(".og-accounting-quickcreatedocument-paymenttype"), DocumentDefinition == '11');
                    Teva.SlideOrFade.Toggle($(".og-accounting-quickcreatedocument-item"), DocumentDefinition != '11');
                } else
                    Teva.SlideOrFade.Show($(".og-accounting-quickcreatedocument-item, .og-accounting-quickcreatedocument-paymenttype"));
            }).trigger("change");
        }

        static InitPayment($Row): void {
            $(".accounting_bankaccount_bank input.bankpicker", $Row).val(Accounting.SelectedCustomer_Bank).trigger("change");
            var BankSelectBox = Teva.SelectBox.GetInstance($(".accounting_bankaccount_bank input.bankpicker", $Row));
            if (BankSelectBox != null)
                BankSelectBox.SetValue(Accounting.SelectedCustomer_Bank, Accounting.SelectedCustomer_Bank, null, Accounting.SelectedCustomer_Bank == null || Accounting.SelectedCustomer_Bank.length == 0);
            $(".accounting_bankaccount_branch input", $Row).val(Accounting.SelectedCustomer_Branch).trigger("change");
            $(".accounting_bankaccount_account input", $Row).val(Accounting.SelectedCustomer_Account).trigger("change");
            $(".accounting_externalcreditcard_lastdigits input", $Row).val(Accounting.SelectedCustomer_LastDigits).trigger("change");
            Accounting.RefreshPaymentsPlaceholder();
        }

        static ShowCustomerNoVatChangedModal(NoVAT) {
            if (NoVAT == true)
                OfficeGuy.Modals.ShowMessageDialog("לקוח/ה פטור/ה ממע\"מ", "לתשומת הלב, בחרת לקוח/ה <u>עם</u> הגדרה של \"פטור ממע\"מ\".<br />משום כך סכום המע\"מ במסמך הוגדר כ-0%.<br />ניתן לשנות הגדרה זו באופן קבוע בכרטיס הלקוח/ה או באופן חד פעמי בהגדרות מטה.<br /><br />בשל המורכבות, מומלץ מאוד לוודא שהסכום תחת סה\"כ הינו תואם את הסכום שאליו התכוונת.")
            else
                OfficeGuy.Modals.ShowMessageDialog("לקוח/ה חייב/ת במע\"מ", "לתשומת הלב, בחרת לקוח/ה <u>ללא</u> הגדרה של \"פטור ממע\"מ\".<br />משום כך סכום המע\"מ במסמך עודכן למע\"מ הנהוג כיום.<br />ניתן לשנות הגדרה זו באופן קבוע בכרטיס הלקוח/ה או באופן חד פעמי בהגדרות מטה.");
        }

        static AccountingTermsSelected($EntityPicker): void {
            var $Input_Date = $(".og-accounting-date input, .og-billing-charge-date input");
            var $Input_DueDate = $(".duedate input.datepicker");
            var Date = Teva.DatePicker.GetDateFromString(<string>$Input_Date.val(), Teva.DatePickerMode.Date);
            var DueDate = null;

            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData;
            if (!Data || !Data.AdditionalFields)
                DueDate = Date;
            else {
                var Days = Data.AdditionalFields["Accounting.PaymentTerms.Days"];
                if (Days == null)
                    Days = 0;
                var DocumentDate = Data.AdditionalFields["Accounting.PaymentTerms.DocumentDate"];
                var Months = Data.AdditionalFields["Accounting.PaymentTerms.Months"];
                if (Months == null)
                    Months = 0;
                DueDate = Date;
                if (DocumentDate != true) {
                    DueDate.setDate(1);
                    DueDate.setMonth(DueDate.getMonth() + 1);
                    DueDate.setDate(0);
                }
                DueDate.setMonth(DueDate.getMonth() + Number(Months));
                DueDate.setDate(DueDate.getDate() + Number(Days));
            }
            var Value = Teva.DatePicker.GetDateAsString(DueDate);
            if ($Input_DueDate.val() != Value)
                $Input_DueDate.val(Value);
        }

        static AccountingCustomerSelected($EntityPicker): void {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData;
            Accounting.SelectedCustomer_Bank = !Data || !Data.AdditionalFields ? "" : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.ActiveBankAccount,Accounting.BankAccounts.BankNumber"];
            if (Accounting.SelectedCustomer_Bank == null)
                Accounting.SelectedCustomer_Bank = "";
            Accounting.SelectedCustomer_Branch = !Data || !Data.AdditionalFields ? "" : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.ActiveBankAccount,Accounting.BankAccounts.BranchNumber"];
            Accounting.SelectedCustomer_Account = !Data || !Data.AdditionalFields ? "" : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.ActiveBankAccount,Accounting.BankAccounts.AccountNumber"];
            Accounting.SelectedCustomer_NoVAT = false;

            if (Data != null) {
                if ($(".og-accounting-vatrate input:hidden").data("originalvalue") == null)
                    $(".og-accounting-vatrate input:hidden").data("originalvalue", $(".og-accounting-vatrate input:hidden:last").val());
                Accounting.SelectedCustomer_NoVAT = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.NoVAT"];
                var NewVATRate = Accounting.SelectedCustomer_NoVAT == true ? "0" : $(".og-accounting-vatrate input:hidden").data("originalvalue");
                if (NewVATRate != $(".og-accounting-vatrate input:hidden:last").val()) {
                    if (!SelectBox.ChangeEventFromInit)
                        Accounting.ShowCustomerNoVatChangedModal(Accounting.SelectedCustomer_NoVAT);
                    if (!SelectBox.ChangeEventFromInit || (Accounting.SelectedCustomer_NoVAT == true))
                        Teva.SelectBox.GetInstance($(".og-accounting-vatrate input:hidden")).SetValue(NewVATRate, NewVATRate + "%");
                }

                if ($(".duedate .entitypicker").length > 0) {
                    var Terms = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms"];
                    if (Terms != null)
                        Teva.SelectBox.GetInstance($(".duedate .entitypicker")).SetValue(Terms.ID, Terms.Name, {
                            schemaid: Terms.SchemaID,
                            AdditionalFields: {
                                "Accounting.PaymentTerms.Days": Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.Days"],
                                "Accounting.PaymentTerms.DocumentDate": Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.DocumentDate"],
                                "Accounting.PaymentTerms.Months": Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.Months"]
                            }
                        });
                    else
                        Teva.SelectBox.GetInstance($(".duedate .entitypicker")).ClearValue();
                }
            }

            if (SelectBox.ChangeEventFromInit && ($(".accounting_bankaccount_bank input:last[value!='']").length != 0 || $(".accounting_bankaccount_branch input[value!='']").length != 0 || $(".accounting_bankaccount_account input[value!='']").length != 0))
                return;

            $(".accounting_bankaccount_bank input.bankpicker").val(Accounting.SelectedCustomer_Bank).trigger("change");
            var $BankInputs = $(".accounting_bankaccount_bank input.bankpicker");
            for (var i = 0; i < $BankInputs.length; i++) {
                var BankSelectBox = Teva.SelectBox.GetInstance($($BankInputs[i]));
                if (BankSelectBox != null)
                    BankSelectBox.SetValue(Accounting.SelectedCustomer_Bank, Accounting.SelectedCustomer_Bank, null, Accounting.SelectedCustomer_Bank == null || Accounting.SelectedCustomer_Bank.length == 0);
            }

            $(".accounting_bankaccount_branch input").val(Accounting.SelectedCustomer_Branch).trigger("change");
            $(".accounting_bankaccount_account input").val(Accounting.SelectedCustomer_Account).trigger("change");
        }

        static AccountingSupplierSelected($EntityPicker): void {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData;
            if (Data == null)
                return;

            if ($(".og-accounting-vatrate input:hidden").data("originalvalue") == null)
                $(".og-accounting-vatrate input:hidden").data("originalvalue", $(".og-accounting-vatrate input:hidden:last").val());

            if ($(".duedate .entitypicker").length > 0) {
                var Terms = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms"];
                if (Terms != null)
                    Teva.SelectBox.GetInstance($(".duedate .entitypicker")).SetValue(Terms.ID, Terms.Name, {
                        schemaid: Terms.SchemaID,
                        AdditionalFields: {
                            "Accounting.PaymentTerms.Days": Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.Days"],
                            "Accounting.PaymentTerms.DocumentDate": Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.DocumentDate"],
                            "Accounting.PaymentTerms.Months": Data.AdditionalFields["Accounting.Customers.CustomersSuppliers.Terms,Accounting.PaymentTerms.Months"]
                        }
                    });
                else
                    Teva.SelectBox.GetInstance($(".duedate .entitypicker")).ClearValue();
            }
            var DefaultExpenseItem = !Data || !Data.AdditionalFields ? null : Data.AdditionalFields["Accounting.Customers.Suppliers.DefaultExpenseItem"];
            if (DefaultExpenseItem) {
                var ItemSelectBox = Teva.SelectBox.GetInstance($(".og-accounting-items-item:first input.entitypicker:hidden"));
                ItemSelectBox.SetValue(DefaultExpenseItem.ID, DefaultExpenseItem.Name, {
                    schemaid: DefaultExpenseItem.SchemaID
                });
            }
        }

        static RoundElementTwoPoints(Element) {
            var Value = Number(<string>Element.val());
            if (!Accounting.IsNumber(Value))
                return;
            var NewValue = Common.RoundTwoPoints(Value);
            if (NewValue != Value)
                Element.val(NewValue);
        }

        static IsNumber(Value): boolean {
            if (typeof Value == "number")
                return !isNaN(Value);
            return Value.length > 0 && !isNaN(Value);
        }

        static MoveValuesBetweenCurrencies() {
            var ForeignCurrencyInput = $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked");
            $("tr.documentitem").each(function () {
                var $Row = $(this);
                var $CompanyValue = $Row.find(".og-accounting-items-unitcompanyvalue input");
                var $DocumentValue = $Row.find(".og-accounting-items-unitdocumentvalue input");
                Accounting.MoveValuesBetweenCurrencies_Inner(ForeignCurrencyInput, $CompanyValue, $DocumentValue);
            });
            $("tr.payment").each(function () {
                var $Row = $(this);
                var $CompanyValue = $Row.find(".og-accounting-payments-companyvalue input");
                var $DocumentValue = $Row.find(".og-accounting-payments-documentvalue input");
                Accounting.MoveValuesBetweenCurrencies_Inner(ForeignCurrencyInput, $CompanyValue, $DocumentValue);
            });
            var $Discount_CompanyValue = $("#og-accounting-items-discountcompanyvalue");
            var $Discount_DocumentValue = $("#og-accounting-items-discountdocumentvalue");
            Accounting.MoveValuesBetweenCurrencies_Inner(ForeignCurrencyInput, $Discount_CompanyValue, $Discount_DocumentValue);
        }
        static MoveValuesBetweenCurrencies_Inner(ForeignCurrencyInput, $CompanyValue, $DocumentValue) {
            if (ForeignCurrencyInput) {
                if ($CompanyValue.val() != "")
                    $DocumentValue.val($CompanyValue.val()).trigger("input");
                $CompanyValue.val("").trigger("input");
            }
            else {
                if ($DocumentValue.val() != "")
                    $CompanyValue.val($DocumentValue.val()).trigger("input");
                $DocumentValue.val("").trigger("input");
            }
        }

        static ShowRoundingSettings() {
            Modals.ShowHTMLDialog({
                HTML: $(".og-accounting-roundingsettings"),
                Title: "עיגול הסה\"כ",
                ShowSubmitButton: true
            });
            return false;
        }
        static ShowLanguageSettings() {
            Modals.ShowHTMLDialog({
                HTML: $(".og-accounting-languagesettings"),
                Title: "שפת המסמך",
                ShowSubmitButton: true
            });
            return false;
        }
        static LanguageChanged() {
            var Language = Teva.SelectBox.GetInstance($(".og-accounting-languagesettings").find("input:hidden")).SelectedText;
            $(".og-accounting-document-settingsmenu-language").text(Language);
        }
        static ShowVATSettings() {
            Modals.ShowHTMLDialog({
                HTML: $(".og-accounting-vatrate"),
                Title: "אחוז מע\"מ",
                ShowSubmitButton: true
            });
            return false;
        }
        static ShowVATIncludedSettings() {
            var VATIncluded = $(".og-accounting-vatincluded input:hidden:last").val() == "True";
            var $Container = $('<div>').addClass('og-accounting-vatincluded')
                .append($('<select>')
                    .append($('<option>').val('True').attr('selected', VATIncluded ? 'selected' : null).text(Resources.GetString("Accounting", "VATIncludedOption_Included")))
                    .append($('<option>').val('False').attr('selected', VATIncluded ? null : 'selected').text(Resources.GetString("Accounting", "VATIncludedOption_NotIncluded")))
                )
                .append($('<a href="/modules/accounting/settings/?keys=PricesIncludeVAT">מעבר להגדרות לשינוי ברירת המחדל »</a>')
                );

            Modals.ShowHTMLDialog({
                HTML: $Container,
                Title: "הזנת מחירים במסמכים",
                ShowSubmitButton: true,
                HideEvent: function () {
                    $(".og-accounting-vatincluded input:hidden:last").val($Container.find(".teva-selectbox-hiddeninput").val()).trigger('change');
                }
            });
            return false;
        }
        static ShowCurrencySettings(IsCharge = false) {
            var $CurrencySettings = $(".og-accounting-currencysettings");

            Modals.ShowHTMLDialog({
                HTML: $CurrencySettings,
                Title: IsCharge ? "מטבע התשלום" : "מטבע המסמך",
                ShowSubmitButton: true,
                HideEvent: function () {
                    if ($(".og-accounting-currencysettings-exchangerate input").val() == "0")
                        $(".og-accounting-currencysettings-exchangerate input").val("");
                    if ($(".og-accounting-currencysettings-exchangerate input").val() != "")
                        $(".og-accounting-currencysettings-customexchangerate input").val("True");
                    Accounting.ToggleForeignCurrency($(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked"));
                    Accounting.MoveValuesBetweenCurrencies();
                    Accounting.RemoveUnusedValues();
                    Accounting.CalculateItemTotals();
                    Accounting.CalculatePaymentTotals();
                }
            });
            return false;
        }
        static SetRoundingFromRadio() {
            var Rounding = $(".og-accounting-roundingradio input:checked").val();
            if (Rounding == null)
                return;
            Accounting.SetRounding(Rounding);
        }
        static SetRounding(Rounding): void {
            var SelectBox = Teva.SelectBox.GetInstance($("input.og-accounting-roundingselect"));
            if ($("input.og-accounting-roundingselect").val() != Rounding) {
                //if (SelectBox == null)
                //$("input.og-accounting-roundingselect").val(Rounding);
                //else
                SelectBox.SetValueFromQueryMethod(Rounding);
            }
            if (Rounding == "0" || Rounding == "2") {
                if ($(".og-accounting-roundingradio input:checked").val() != Rounding)
                    $(".og-accounting-roundingradio input[value='" + Rounding + "']").prop("checked", true).trigger("change");
            }
            else
                $(".og-accounting-roundingradio input:checked").prop("checked", false).trigger("change");
            Accounting.Rounding = Number(Rounding);
            Accounting.CalculateItemTotals();
            $(".og-accounting-document-settingsmenu-rounding").text(SelectBox.SelectedText);
        }

        static GetRoundedValue(Value) {
            switch (Accounting.Rounding) {
                case 1:
                case 2:
                case 3:
                case 4:
                    var Multiplier = Math.pow(10, Accounting.Rounding) / 100;
                    return Math.round(Value / Multiplier) * Multiplier;
                case 0:
                default:
                    return Value;
            }
        }
        static PreSubmit(IsDraft: boolean) {
            $('.og-accounting-draft input').val(IsDraft ? 'True' : 'False');
            var $HiddenContainer = $(".documentitems_hidden").empty();
            var Index = $(".documentitems tbody tr").length;
            var VATIncluded = $(".og-accounting-vatincluded input:hidden:last").val() == "True";

            var ForeignCurrencyInput = $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked");

            var Discount_CompanyValue = $("#og-accounting-items-discountcompanyvalue").data("absolute") == null ? Number($("#og-accounting-items-discountcompanyvalue").val()) : <Number>$("#og-accounting-items-discountcompanyvalue").data("absolute");
            var Discount_DocumentValue = $("#og-accounting-items-discountdocumentvalue").data("absolute") == null ? Number($("#og-accounting-items-discountdocumentvalue").val()) : <Number>$("#og-accounting-items-discountdocumentvalue").data("absolute");
            if (ForeignCurrencyInput)
                Discount_CompanyValue = 0;
            else
                Discount_DocumentValue = 0;
            if (Discount_CompanyValue != 0 || Discount_DocumentValue != 0) {
                if (Discount_CompanyValue != 0) {
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].UnitCompanyValue" + (VATIncluded ? "WithVAT" : ""))
                        .val((-Discount_CompanyValue).toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].CompanyValue" + (VATIncluded ? "WithVAT" : ""))
                        .val((-Discount_CompanyValue).toString()));
                }
                if (Discount_DocumentValue != 0) {
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].UnitDocumentValue" + (VATIncluded ? "WithVAT" : ""))
                        .val((-Discount_DocumentValue).toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].DocumentValue" + (VATIncluded ? "WithVAT" : ""))
                        .val((-Discount_DocumentValue).toString()));
                }
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Data.IncomeItems[" + Index + "].Quantity")
                    .val("1"));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Data.IncomeItems[" + Index + "].Element.ID")
                    .val(Accounting.DiscountElementID.toString()));
                Index++;
            }

            var Rounding_CompanyValue = Number($("input.og-accounting-items-roundingcompanyvalue[type=hidden]").val());
            if (isNaN(Rounding_CompanyValue))
                Rounding_CompanyValue = 0;
            var Rounding_CompanyValueWithVAT = Number($(".og-accounting-items-roundingcompanyvaluewithvat").val());
            if (isNaN(Rounding_CompanyValueWithVAT))
                Rounding_CompanyValueWithVAT = 0;
            var Rounding_DocumentValue = Number($("input.og-accounting-items-roundingdocumentvalue[type=hidden]").val());
            if (isNaN(Rounding_DocumentValue))
                Rounding_DocumentValue = 0;
            var Rounding_DocumentValueWithVAT = Number($(".og-accounting-items-roundingdocumentvaluewithvat").val());
            if (isNaN(Rounding_DocumentValueWithVAT))
                Rounding_DocumentValueWithVAT = 0;
            if (ForeignCurrencyInput) {
                Rounding_CompanyValue = 0;
                Rounding_CompanyValueWithVAT = 0;
            }
            else {
                Rounding_DocumentValue = 0;
                Rounding_DocumentValueWithVAT = 0;
            }
            if (Rounding_CompanyValueWithVAT != 0 || Rounding_DocumentValueWithVAT != 0) {
                if (Rounding_CompanyValueWithVAT != 0) {
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].UnitCompanyValueWithVAT")
                        .val(Rounding_CompanyValueWithVAT.toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].UnitCompanyValue")
                        .val(Rounding_CompanyValue.toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].CompanyValueWithVAT")
                        .val(Rounding_CompanyValueWithVAT.toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].CompanyValue")
                        .val(Rounding_CompanyValue.toString()));
                }
                if (Rounding_DocumentValueWithVAT != 0) {
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].UnitDocumentValueWithVAT")
                        .val(Rounding_DocumentValueWithVAT.toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].UnitDocumentValue")
                        .val(Rounding_DocumentValue.toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].DocumentValueWithVAT")
                        .val(Rounding_DocumentValueWithVAT.toString()));
                    $HiddenContainer.append($(document.createElement('input'))
                        .attr("type", "hidden")
                        .attr("name", "Data.IncomeItems[" + Index + "].DocumentValue")
                        .val(Rounding_DocumentValue.toString()));
                }
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Data.IncomeItems[" + Index + "].Quantity")
                    .val("1"));
                $HiddenContainer.append($(document.createElement('input'))
                    .attr("type", "hidden")
                    .attr("name", "Data.IncomeItems[" + Index + "].Element.ID")
                    .val(Accounting.RoundingElementID.toString()));
                Index++;
            }
        }

        static RemoveUnusedValues() {
            if ($(".currency-foreign:visible").length != 0) {
                $(".og-accounting-items-unitcompanyvalue input, .og-accounting-items-companyvalue input").val("");
                $(".og-accounting-items-discountcompanyvalue").val("");
                $("input.og-accounting-items-roundingcompanyvalue, #og-accounting-items-roundingcompanyvaluewithvat").val("");
                $("input.og-accounting-items-totalcompanyvaluewithoutvat, input.og-accounting-items-totalcompanyvaluewithvat").val("");
                $("span.og-accounting-items-totalcompanyvaluewithvat").text("");
                $(".og-accounting-payments-companyvalue input").val("");
            }
            else {
                $(".og-accounting-items-unitdocumentvalue input, .og-accounting-items-documentvalue input").val("");
                $(".og-accounting-items-discountdocumentvalue").val("");
                $(".og-accounting-items-roundingdocumentvalue, .og-accounting-items-roundingdocumentvaluewithvat").val("");
                $("input.og-accounting-items-totaldocumentvaluewithoutvat, input.og-accounting-items-totaldocumentvaluewithvat").val("");
                $("span.og-accounting-items-totaldocumentvaluewithvat").text("");
                $(".og-accounting-payments-documentvalue input").val("");
            }
        }

        static RefreshVATIncludedFields(): void {
            var VATIncluded = $(".og-accounting-vatincluded input").prop("checked") || $(".og-accounting-vatincluded input").val() == "True";
            if (Accounting.IsBilling)
                return;

            var MultipleVAT = $(".documentitems").hasClass("og-accounting-document-multiplevat");
            var UnitVATIncluded = VATIncluded && !MultipleVAT;
            $(".documentitem .og-accounting-items-unitcompanyvalue input, .documentitem .og-accounting-items-unitdocumentvalue input").each(function () {
                var $this = $(this);
                if (UnitVATIncluded && !Accounting.EndsWith($this.attr("name"), "WithVAT"))
                    this.setAttribute("name", this.getAttribute("name") + "WithVAT");
                else if (!UnitVATIncluded && Accounting.EndsWith($this.attr("name"), "WithVAT"))
                    this.setAttribute("name", this.getAttribute("name").substring(0, $this.attr("name").length - "WithVAT".length));
            });
            $(".documentitem .og-accounting-items-companyvalue input, .documentitem .og-accounting-items-documentvalue input").each(function () {
                var $this = $(this);
                if (VATIncluded && !Accounting.EndsWith($this.attr("name"), "WithVAT"))
                    this.setAttribute("name", this.getAttribute("name") + "WithVAT");
                else if (!VATIncluded && Accounting.EndsWith($this.attr("name"), "WithVAT"))
                    this.setAttribute("name", this.getAttribute("name").substring(0, $this.attr("name").length - "WithVAT".length));
            });
        }

        static CalculateItemTotals(): void {
            Accounting.RefreshVATIncludedFields();
            if ($(".currency-foreign:visible").length != 0)
                Accounting.CalculateItemTotals_DocumentValue();
            else
                Accounting.CalculateItemTotals_CompanyValue();
        }

        static CalculateItemTotals_CompanyValue(): void {
            var VATMultiplier: number;
            if ($(".og-accounting-vatrate input:hidden").length > 0)
                VATMultiplier = (Number($(".og-accounting-vatrate input:hidden:last").val()) + 100) / 100;
            else
                VATMultiplier = (Number($("input.og-accounting-items-totalcompanyvaluewithvat").attr("data-missingvat")) + 100) / 100;
            var VATIncluded = $(".og-accounting-vatincluded input").prop("checked") || $(".og-accounting-vatincluded input").val() == "True";
            var MultipleVAT = $(".documentitems").hasClass("og-accounting-document-multiplevat");

            var Total_WithoutVAT = 0, Total_WithVAT = 0;

            $(".documentitem").each(function () {
                var $this = $(this);
                var Value = $(".og-accounting-items-companyvalue input", $this).val();
                if (!Accounting.IsNumber(Value))
                    return;

                if (Total_WithoutVAT != null) {
                    if (VATIncluded) {
                        if (MultipleVAT)
                            Total_WithoutVAT += Number(Value) - Number($this.find(".og-accounting-items-multiplevat input").val());
                        else
                            Total_WithoutVAT += Common.RoundTwoPoints(Number(Value) / VATMultiplier);
                        Total_WithVAT += Number(Value);
                    }
                    else {
                        Total_WithoutVAT += Number(Value);
                        if (MultipleVAT)
                            Total_WithVAT += Number(Value) + Number($this.find(".og-accounting-items-multiplevat input").val());
                        else
                            Total_WithVAT += Common.RoundTwoPoints(Number(Value) * VATMultiplier);
                    }
                }
            });

            var Discount = Number(<string>$("#og-accounting-items-discountcompanyvalue").val());
            $("#og-accounting-items-discountcompanyvalue").data("absolute", null);
            if ($("#og-accounting-items-discountcompanyvalue").length != 0 && Discount != 0) {
                if (!Accounting.IsNumber(Discount)) {
                    Total_WithoutVAT = null;
                    Total_WithVAT = null;
                }
                else if (Total_WithoutVAT != null) {
                    if ($(".og-accounting-items-discounttype input:checked").val() == "1") { // Percent
                        $('.og-accounting-items-discountpercent').val(Number(Discount));
                        if (VATIncluded) {
                            Discount = Common.RoundTwoPoints(Number(Discount) * Total_WithVAT / 100);
                            $("#og-accounting-items-discountcompanyvalue").data("absolute", Common.RoundTwoPoints(Discount));

                            Total_WithoutVAT -= Common.RoundTwoPoints(Discount / VATMultiplier);
                            Total_WithVAT -= Discount;
                        }
                        else {
                            Discount = Common.RoundTwoPoints(Number(Discount) * Total_WithoutVAT / 100);
                            $("#og-accounting-items-discountcompanyvalue").data("absolute", Discount);

                            Total_WithoutVAT -= Discount;
                            Total_WithVAT -= Common.RoundTwoPoints(Discount * VATMultiplier);
                        }
                    }
                    else {
                        $('.og-accounting-items-discountpercent').val('');
                        if (VATIncluded) {
                            $("#og-accounting-items-discountcompanyvalue").data("absolute", Common.RoundTwoPoints(Discount));
                            Total_WithoutVAT -= Common.RoundTwoPoints(Discount / VATMultiplier);
                            Total_WithVAT -= Discount;
                        }
                        else {
                            Total_WithoutVAT -= Discount;
                            Total_WithVAT -= Common.RoundTwoPoints(Discount * VATMultiplier);
                        }
                    }
                }
            }

            var Rounding_WithVAT = 0, Rounding_WithoutVAT = 0;
            if (Total_WithVAT != null) {
                Rounding_WithVAT = Common.RoundTwoPoints(Common.RoundTwoPoints(Accounting.GetRoundedValue(Total_WithVAT)) - Total_WithVAT);
                Rounding_WithoutVAT = Common.RoundTwoPoints(Rounding_WithVAT / VATMultiplier);
                Total_WithoutVAT = Common.RoundTwoPoints(Total_WithoutVAT + Rounding_WithoutVAT);
                Total_WithVAT = Common.RoundTwoPoints(Total_WithVAT + Rounding_WithVAT);
            }
            var Total_VAT = Total_WithVAT == null || Total_WithoutVAT == null ? null : Common.RoundTwoPoints(Total_WithVAT - Total_WithoutVAT)

            var Currency = $(".og-accounting-currency input.currencypicker").val();
            if (VATIncluded) {
                $("input.og-accounting-items-roundingcompanyvalue[type=hidden]").val(Rounding_WithVAT);
                $("input.og-accounting-items-roundingcompanyvalue[type=text]").val(Rounding_WithVAT == null ? "" : Rounding_WithVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            }
            else {
                $("input.og-accounting-items-roundingcompanyvalue[type=hidden]").val(Rounding_WithoutVAT);
                $("input.og-accounting-items-roundingcompanyvalue[type=text]").val(Rounding_WithoutVAT == null ? "" : Rounding_WithoutVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            }
            $(".og-accounting-items-roundingcompanyvaluewithvat").val(Rounding_WithVAT);
            //$(".og-accounting-items-roundingrow").toggle(Rounding_WithVAT != 0);

            if ($("input.og-accounting-items-totalcompanyvaluewithoutvat[type=hidden]").val() != (Total_WithoutVAT == null ? "" : Total_WithoutVAT.toString())) {
                $("input.og-accounting-items-totalcompanyvaluewithoutvat[type=hidden]").val(Total_WithoutVAT == null ? "" : Total_WithoutVAT.toString()).trigger("change");
                $("input.og-accounting-items-totalcompanyvaluewithoutvat[type=text]").val(Total_WithoutVAT == null ? "" : Total_WithoutVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            }
            if ($("input.og-accounting-items-totalcompanyvaluewithvat[type=hidden]").val() != (Total_WithVAT == null ? "" : Total_WithVAT.toString())) {
                $("input.og-accounting-items-totalcompanyvaluewithvat[type=hidden]").val(Total_WithVAT == null ? "" : Total_WithVAT.toString()).trigger("change");
                $("span.og-accounting-items-totalcompanyvaluewithvat").html(Accounting.FormatCurrencySummary(Total_WithVAT, Accounting.IsBilling ? Currency : "1"));
            }
            if ($("input.og-accounting-items-totalcompanyvaluevat[type=text]").val() != (Total_VAT == null ? "" : Total_VAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })))
                $("input.og-accounting-items-totalcompanyvaluevat[type=text]").val(Total_VAT == null ? "" : Total_VAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");

            Accounting.RefreshPaymentsPlaceholder();
        }

        static CalculateItemTotals_DocumentValue(): void {
            var VATMultiplier: number;
            if ($(".og-accounting-vatrate input:hidden").length > 0)
                VATMultiplier = (Number($(".og-accounting-vatrate input:hidden:last").val()) + 100) / 100;
            else
                VATMultiplier = (Number($("input.og-accounting-items-totalcompanyvaluewithvat").attr("data-missingvat")) + 100) / 100;
            var VATIncluded = $(".og-accounting-vatincluded input").prop("checked") || $(".og-accounting-vatincluded input").val() == "True";
            var MultipleVAT = $(".documentitems").hasClass("og-accounting-document-multiplevat");

            var Total_WithoutVAT = 0, Total_WithVAT = 0;

            $(".documentitem").each(function () {
                var $this = $(this);
                var Value = $(".og-accounting-items-documentvalue input", $this).val();
                if (!Accounting.IsNumber(Value))
                    return;

                if (Total_WithoutVAT != null) {
                    if (VATIncluded) {
                        if (MultipleVAT)
                            Total_WithoutVAT += Number(Value) - Number($this.find(".og-accounting-items-multiplevat input").val());
                        else
                            Total_WithoutVAT += Common.RoundTwoPoints(Number(Value) / VATMultiplier);
                        Total_WithVAT += Number(Value);
                    }
                    else {
                        Total_WithoutVAT += Number(Value);
                        if (MultipleVAT)
                            Total_WithVAT += Number(Value) + Number($this.find(".og-accounting-items-multiplevat input").val());
                        else
                            Total_WithVAT += Common.RoundTwoPoints(Number(Value) * VATMultiplier);
                    }
                }
            });

            var Discount = Number(<string>$("#og-accounting-items-discountdocumentvalue").val());
            $("#og-accounting-items-discountdocumentvalue").data("absolute", null);
            if ($("#og-accounting-items-discountdocumentvalue").length != 0 && Discount != 0) {
                if (!Accounting.IsNumber(Discount)) {
                    Total_WithoutVAT = null;
                    Total_WithVAT = null;
                }
                else if (Total_WithoutVAT != null) {
                    if ($(".og-accounting-items-discounttype input:checked").val() == "1") { // Percent
                        $('.og-accounting-items-discountpercent').val(Number(Discount));
                        if (VATIncluded) {
                            Discount = Common.RoundTwoPoints(Number(Discount) * Total_WithVAT / 100);
                            $("#og-accounting-items-discountdocumentvalue").data("absolute", Common.RoundTwoPoints(Discount));

                            Total_WithoutVAT -= Common.RoundTwoPoints(Discount / VATMultiplier);
                            Total_WithVAT -= Discount;
                        }
                        else {
                            Discount = Common.RoundTwoPoints(Number(Discount) * Total_WithoutVAT / 100);
                            $("#og-accounting-items-discountdocumentvalue").data("absolute", Discount);

                            Total_WithoutVAT -= Discount;
                            Total_WithVAT -= Common.RoundTwoPoints(Discount * VATMultiplier);
                        }
                    }
                    else {
                        $('.og-accounting-items-discountpercent').val('');
                        if (VATIncluded) {
                            $("#og-accounting-items-discountdocumentvalue").data("absolute", Common.RoundTwoPoints(Discount));
                            Total_WithoutVAT -= Common.RoundTwoPoints(Discount / VATMultiplier);
                            Total_WithVAT -= Discount;
                        }
                        else {
                            Total_WithoutVAT -= Discount;
                            Total_WithVAT -= Common.RoundTwoPoints(Discount * VATMultiplier);
                        }
                    }
                }
            }

            var Rounding_WithVAT = 0, Rounding_WithoutVAT = 0;
            if (Total_WithVAT != null) {
                Rounding_WithVAT = Common.RoundTwoPoints(Common.RoundTwoPoints(Accounting.GetRoundedValue(Total_WithVAT)) - Total_WithVAT);
                Rounding_WithoutVAT = Common.RoundTwoPoints(Rounding_WithVAT / VATMultiplier);
                Total_WithoutVAT = Common.RoundTwoPoints(Total_WithoutVAT + Rounding_WithoutVAT);
                Total_WithVAT = Common.RoundTwoPoints(Total_WithVAT + Rounding_WithVAT);
            }
            var Total_VAT = Total_WithVAT == null || Total_WithoutVAT == null ? null : Common.RoundTwoPoints(Total_WithVAT - Total_WithoutVAT)

            var Currency = $(".og-accounting-currency input.currencypicker").val();
            $(".og-accounting-items-roundingdocumentvaluewithvat").val(Rounding_WithVAT);
            if (VATIncluded) {
                $("input.og-accounting-items-roundingdocumentvalue[type=hidden]").val(Rounding_WithVAT);
                $("input.og-accounting-items-roundingdocumentvalue[type=text]").val(Rounding_WithVAT == null ? null : Rounding_WithVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            }
            else {
                $("input.og-accounting-items-roundingdocumentvalue[type=hidden]").val(Rounding_WithoutVAT);
                $("input.og-accounting-items-roundingdocumentvalue[type=text]").val(Rounding_WithoutVAT == null ? null : Rounding_WithoutVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            }
            //$(".og-accounting-items-roundingrow").toggle(Rounding_WithVAT != 0);

            if ($("input.og-accounting-items-totaldocumentvaluewithoutvat[type=hidden]").val() != (Total_WithoutVAT == null ? "" : Total_WithoutVAT.toString())) {
                $("input.og-accounting-items-totaldocumentvaluewithoutvat[type=hidden]").val(Total_WithoutVAT == null ? "" : Total_WithoutVAT.toString()).trigger("change");
                $("input.og-accounting-items-totaldocumentvaluewithoutvat[type=text]").val(Total_WithoutVAT == null ? null : Total_WithoutVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            }
            if ($("input.og-accounting-items-totaldocumentvaluewithvat[type=hidden]").val() != (Total_WithVAT == null ? "" : Total_WithVAT.toString())) {
                $("input.og-accounting-items-totaldocumentvaluewithvat[type=hidden]").val(Total_WithVAT == null ? "" : Total_WithVAT.toString()).trigger("change");
                $("span.og-accounting-items-totaldocumentvaluewithvat").html(Accounting.FormatCurrencySummary(Total_WithVAT, Currency));
            }
            if ($("input.og-accounting-items-totaldocumentvaluevat[type=text]").val() != (Total_VAT == null ? "" : Total_VAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })))
                $("input.og-accounting-items-totaldocumentvaluevat[type=text]").val(Total_VAT == null ? "" : Total_VAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");

            Accounting.RefreshPaymentsPlaceholder();
        }

        static RefreshPaymentsPlaceholder() {
            if ($(".currency-foreign:visible").length != 0) {
                if ($("input.og-accounting-items-totaldocumentvaluewithvat").val() == "" || $(".payment").length != 1)
                    $(".payment .og-accounting-payments-documentvalue input").attr("placeholder", "0");
                else
                    $(".payment .og-accounting-payments-documentvalue input").attr("placeholder", <string>$("input.og-accounting-items-totaldocumentvaluewithvat").val());
            }
            else {
                if ($("input.og-accounting-items-totalcompanyvaluewithvat").val() == "" || $(".payment").length != 1)
                    $(".payment .og-accounting-payments-companyvalue input").attr("placeholder", "0");
                else
                    $(".payment .og-accounting-payments-companyvalue input").attr("placeholder", <string>$("input.og-accounting-items-totalcompanyvaluewithvat").val());
            }
            Accounting.CalculatePaymentTotals();
        }

        static CalculatePaymentTotals(): void {
            if ($(".currency-foreign:visible").length != 0)
                Accounting.CalculatePaymentTotals_DocumentValue();
            else
                Accounting.CalculatePaymentTotals_CompanyValue();
        }
        static CalculatePaymentTotals_CompanyValue(): void {
            var Total = 0;

            $(".payment").each(function () {
                var Value = <string>$(".og-accounting-payments-companyvalue input", $(this)).val();
                if (Value.length == 0)
                    Value = $(".og-accounting-payments-companyvalue input", $(this)).attr("placeholder");
                if (Value.length != 0) {
                    if (!Accounting.IsNumber(Value))
                        Total = null;
                    else if (Total != null)
                        Total += Number(Value);
                }
            });
            if (Total != null)
                Total = Common.RoundTwoPoints(Total);

            var ForeignCurrencyInput = $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked");
            var Currency = $(".og-accounting-currency input.currencypicker").val();
            $("span.og-accounting-payments-totalcompanyvalue").html(Total == null ? "" : Accounting.FormatCurrencySummary(Total, ForeignCurrencyInput ? Currency : "1"));
        }
        static CalculatePaymentTotals_DocumentValue(): void {
            var Total = 0;

            $(".payment").each(function () {
                var Value = <string>$(".og-accounting-payments-documentvalue input", $(this)).val();
                if (Value.length == 0)
                    Value = $(".og-accounting-payments-documentvalue input", $(this)).attr("placeholder");
                if (Value.length != 0) {
                    if (!Accounting.IsNumber(Value))
                        Total = null;
                    else if (Total != null)
                        Total += Number(Value);
                }
            });
            if (Total != null)
                Total = Common.RoundTwoPoints(Total);

            var ForeignCurrencyInput = $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked");
            var Currency = $(".og-accounting-currency input.currencypicker").val();
            $("span.og-accounting-payments-totaldocumentvalue").html(Total == null ? "" : Accounting.FormatCurrencySummary(Total, ForeignCurrencyInput ? Currency : "1"));
        }

        static CalculateManualMatch(): void {
            var Checked = false;
            var Total = 0;
            $(".manualmatch tbody input:checkbox:checked").each(function () {
                var $Row = $(this).closest('tr');
                Total += Number($Row.attr("data-total"));
                Checked = true;
            });
            Total = Common.RoundTwoPoints(Total);
            $(".og-bankreconciliation-manual-summary")
                .toggle(Total != 0 || $(".manualmatch tbody input:checkbox:checked").length > 0)
                .toggleClass("og-bankreconciliation-manual-summary-valid", Total == 0);
            $(".og-bankreconciliation-manual-summary span").text(Total.toLocaleString('he-IL', { maximumFractionDigits: 2 }));

            $("tr.og-books-matching-highlight").removeClass("og-books-matching-highlight");
            $("tr[data-total='" + (-Total) + "']").addClass("og-books-matching-highlight");

            OfficeGuy.CRM.EntitiesList.ToggleSelectedMenu(Checked);
        }

        static ToggleForeignCurrency(ForeignCurrencyVisible?: boolean): void {
            if (ForeignCurrencyVisible == null)
                ForeignCurrencyVisible = $(".currency-foreign:visible").length == 0;
            var Currency = $(".og-accounting-currency input.currencypicker").val();
            var CurrencyRemarksText = null;
            if (Currency != "1" && $(".og-accounting-currencysettings-customexchangerate input").val() == "True") {
                var ExchangeRate = $(".og-accounting-currencysettings-exchangerate input").val();
                if (ExchangeRate != "")
                    CurrencyRemarksText = " (שער: " + ExchangeRate + ")";
            }
            var $CurrencyRemarks = $('.og-accounting-currency .sumit-field-label label span');
            if ($CurrencyRemarks.length == 0 && CurrencyRemarksText != null)
                $CurrencyRemarks = $(document.createElement('span'))
                    .appendTo($('.og-accounting-currency .sumit-field-label label'));
            $CurrencyRemarks.text(CurrencyRemarksText);
            $(".og-accounting-document-settingsmenu-currency").text(Accounting.ShortCurrencyName(Currency));
            if (Currency != "1") {
                $(".og-accounting-items-unitcompanyvalue label").text(OfficeGuy.Resources.GetString("Accounting", "Price") + " (" + Accounting.ShortCurrencyName(Accounting.IsBilling ? Currency : "1") + ")");
                $(".og-accounting-items-companyvalue label").text(OfficeGuy.Resources.GetString("Accounting", "Total") + " (" + Accounting.ShortCurrencyName(Accounting.IsBilling ? Currency : "1") + ")");
                $(".og-accounting-payments-documentvalue label").text(OfficeGuy.Resources.GetString("Accounting", "PaymentAmount") + " (" + Accounting.ShortCurrencyName(Currency) + ")");
                $(".og-accounting-items-multiplevat label").text(OfficeGuy.Resources.GetString("Accounting", "VAT") + " (" + Accounting.ShortCurrencyName(ForeignCurrencyVisible ? Currency : "1") + ")");
            }
            else {
                $(".og-accounting-items-unitcompanyvalue label").text(OfficeGuy.Resources.GetString("Accounting", "Price"));
                $(".og-accounting-items-companyvalue label").text(OfficeGuy.Resources.GetString("Accounting", "Total"));
                $(".og-accounting-items-multiplevat label").text(OfficeGuy.Resources.GetString("Accounting", "VAT"));
                $(".og-accounting-payments-companyvalue label").text(OfficeGuy.Resources.GetString("Accounting", "PaymentAmount"));
            }

            var MultipleVATVisible = $(".documentitems").hasClass("og-accounting-document-multiplevat");
            var QuantitiesVisible = $(".og-accounting-items-quantity input").filter(function () { return (<string>$(this).val()).length > 0 && $(this).val() != '0' && $(this).val() != '1' && $(this).val() != '-1'; }).length > 0 || MultipleVATVisible;

            $(".documentitems, .payments").toggleClass("og-accounting-document-quantities", QuantitiesVisible);
            $(".documentitems, .documentitemsfooter, .payments, .paymentsfooter").toggleClass("og-accounting-document-foreigncurrency", ForeignCurrencyVisible);

            if (ForeignCurrencyVisible) {
                $(".og-accounting-items-unitdocumentvalue label").text(OfficeGuy.Resources.GetString("Accounting", "Price") + " (" + Accounting.ShortCurrencyName(Currency) + ")");
                $(".og-accounting-items-documentvalue label").text(OfficeGuy.Resources.GetString("Accounting", "Total") + " (" + Accounting.ShortCurrencyName(Currency) + ")");
                $(".og-accounting-items-discounttype label:first span").text(Accounting.ShortCurrencyName(Currency));
            }
            else
                $(".og-accounting-items-discounttype label:first span").text(Accounting.ShortCurrencyName("1"));

            var TotalDocumentValueWithoutVAT = Number($("input.og-accounting-items-totaldocumentvaluewithoutvat[type=hidden]").val());
            if (isNaN(TotalDocumentValueWithoutVAT))
                TotalDocumentValueWithoutVAT = null;
            $("input.og-accounting-items-totaldocumentvaluewithoutvat[type=text]").val(TotalDocumentValueWithoutVAT == null ? null : TotalDocumentValueWithoutVAT.toLocaleString('he-IL', { maximumFractionDigits: 2 })).trigger("change");
            $("span.og-accounting-items-totaldocumentvaluewithvat").html(Accounting.FormatCurrencySummary($("input.og-accounting-items-totaldocumentvaluewithvat[type=hidden]").val(), Currency));

            $("input.og-accounting-items-totalcompanyvaluewithoutvat[type=text]").val($("input.og-accounting-items-totalcompanyvaluewithoutvat[type=hidden]").val()).trigger("change");
            $("span.og-accounting-items-totalcompanyvaluewithvat").html(Accounting.FormatCurrencySummary($("input.og-accounting-items-totalcompanyvaluewithvat[type=hidden]").val(), Accounting.IsBilling ? Currency : "1"));
        }

        static RefreshForeignCurrency(): void {
            Accounting.ToggleForeignCurrency($(".og-accounting-currency input.currencypicker").length > 0 && $(".og-accounting-currency input.currencypicker").val() != "1" && $(".og-accounting-currencysettings-foreigncurrencyinput input").prop("checked"));
        }

        static RefreshQuantities(): void {
            var MultipleVATVisible = $(".documentitems").hasClass("og-accounting-document-multiplevat");
            var QuantitiesVisible = $(".og-accounting-items-quantity input").filter(function () { return (<string>$(this).val()).length > 0 && $(this).val() != '0' && $(this).val() != '1' && $(this).val() != '-1'; }).length > 0 || MultipleVATVisible;
            var ForeignCurrencyVisible = $(".quantities.currency-foreign").length > 0 && $(".currency-foreign:visible").length > 0;

            $(".documentitems, .payments").toggleClass("og-accounting-document-quantities", QuantitiesVisible);
            $(".documentitems, .documentitemsfooter, .payments, .paymentsfooter").toggleClass("og-accounting-document-foreigncurrency", ForeignCurrencyVisible);
        }

        static Payments_Add(Method?) {
            if (Method == null)
                Method = <string>$(".payment").last().find(".og-accounting-payments-paymentmethod input.teva-selectbox-hiddeninput").val();
            var Template = Accounting.PaymentsTemplates[Method];
            var $NewRow = Forms.NestedForm_Add('tbody.payments', 'tbody.payments', Accounting.PaymentsTemplatesTicks, Template, false);

            OfficeGuy.Apps.Accounting.RefreshForeignCurrency();
            OfficeGuy.Apps.Accounting.CalculatePaymentTotals();
            OfficeGuy.Apps.Accounting.InitPayment($NewRow);

            setTimeout(function () {
                Teva.Positioning.ScrollToElement($NewRow);
            }, 100);

            return false;
        }
        static Payments_AddCheques($Cheque) {
            var $MasterRow = $Cheque.closest(".payment");
            var CompanyValue = $("input[id$=CompanyValue]", $MasterRow).val();
            var PaymentDate = (<string>$("input[id$=PaymentDate]", $MasterRow).val()).length == 0 ? null : Teva.DatePicker.GetDateFromString(<string>$("input[id$=PaymentDate]", $MasterRow).val(), Teva.DatePickerMode.Date);
            var ChequeNumber = <string>$("input[id$=ChequeNumber]", $MasterRow).val();
            var BankNumber = $("input[id$=BankNumber]", $MasterRow).val();
            var BranchNumber = $("input[id$=BranchNumber]", $MasterRow).val();
            var AccountNumber = $("input[id$=AccountNumber]", $MasterRow).val();

            var $Modal = OfficeGuy.Modals.ShowInputDialog({
                Title: "הזנה אוטומטית של שיקים",
                Message: "כמות השיקים להוספה",
                ConfirmText: "הוספת שיקים",
                RemarkHTML: true,
                Remark: "<ul><li>הסכום של כל השיקים יועתק מהשיק הנוכחי</li><li>תאריך הפרעון של כל אחד מהשיקים יהיה חודש קדימה מהשיק הקודם</li><li>מספר השיק של כל אחד מהשיקים יהיה עוקב למספר השיק הקודם</li></ul>",
                InputClass: "input-Int64",
                ConfirmEvent: function (Value) {
                    if (isNaN(Value))
                        return;

                    var Template = Accounting.PaymentsTemplates[$MasterRow.find(".og-accounting-payments-paymentmethod input").val()];
                    var $FirstRow;
                    for (var i = 0; i < Number(Value); i++) {
                        var $NewRow = Forms.NestedForm_Add('tbody.payments', 'tbody.payments', Accounting.PaymentsTemplatesTicks, Template, false);
                        if (i == 0)
                            $FirstRow = $NewRow;
                        OfficeGuy.Apps.Accounting.InitPayment($NewRow);

                        if (PaymentDate != null) {
                            PaymentDate.setMonth(PaymentDate.getMonth() + 1);
                            $("input[id$=PaymentDate]", $NewRow).val(Teva.DatePicker.GetDateAsString(PaymentDate));
                        }
                        if (ChequeNumber.length != 0 && !isNaN(Number(ChequeNumber)))
                            $("input[id$=ChequeNumber]", $NewRow).val(Number(ChequeNumber) + 1 + i);

                        $("input[id$=CompanyValue]", $NewRow).val(CompanyValue);
                        Teva.SelectBox.GetInstance($("input[id$=BankNumber]", $NewRow)).SetValueFromQueryMethod(BankNumber);
                        $("input[id$=BranchNumber]", $NewRow).val(BranchNumber);
                        $("input[id$=AccountNumber]", $NewRow).val(AccountNumber);
                    }

                    OfficeGuy.Apps.Accounting.RefreshForeignCurrency();
                    OfficeGuy.Apps.Accounting.CalculatePaymentTotals();

                    Modals.Hide($Modal);
                    setTimeout(function () {
                        Teva.Positioning.ScrollToElement($FirstRow);
                    }, 100);
                }
            });
            return false;
        }
        static Payments_Change(Value, Text, Data, Instance): boolean {
            if (Value == "CreditCardRedirect") {
                Instance.SetValue("");
                Forms.DirtyNavigation(function () {
                    Navigation.Redirect("/billing/charge/?paymentmethodtype=CreditCard");
                });
                return false;
            }
            else if (Data != null && Data.type != null && Data.type == "CreditCardIncome")
                Modals.ShowMessageDialog("תקבול חיצוני באשראי", "יצירת מסמך עבור \"תנועת אשראי חיצונית\" נועדה ליצירת תיעוד חשבונאי על סליקה שביצעתם באמצעות מערכת אחרת.<br />על מנת לבצע סליקת אשראי יש ללחוץ על \"סליקת אשראי\" בדף הבית.");
            else if (Data != null && Data.type != null && Data.type == "Cheque" && Accounting.IsCredit)
                Modals.ShowMessageDialog("יצירת זיכוי", "לתשומת הלב,<br />בחרת להוסיף שיק למסמך זיכוי שלא נוצר מתוך מסמך רגיל.<br /><br />במידה והשיק שאתם רוצים להזין הוא שיק שלכם והכסף באמת ייצא מהחשבון - הכל בסדר ותתעלמו מההודעה.<br />במידה ואתם רוצים להכניס פה פרטים של שיק שקיבלתם מהלקוח/ה ועכשיו אתם מחזירים אותו - אנחנו מציעים לעצור את התהליך, למצוא את המסמך המקורי, וליצור את הזיכוי דרכו.");
            var Template = Accounting.PaymentsTemplates[Value];
            var $PreviousRow = Instance.$Input.closest('tr');
            var CompanyValue = $PreviousRow.find('.og-accounting-payments-companyvalue input').val();
            var DocumentValue = $PreviousRow.find('.og-accounting-payments-documentvalue input').val();
            var $NewRow = Forms.NestedForm_Replace('tbody.payments', Accounting.PaymentsTemplatesTicks, Template, Instance.$Input.closest('tr').index());
            $NewRow.find('.og-accounting-payments-companyvalue input').val(CompanyValue);
            $NewRow.find('.og-accounting-payments-documentvalue input').val(DocumentValue);

            OfficeGuy.Apps.Accounting.RefreshForeignCurrency();
            OfficeGuy.Apps.Accounting.CalculatePaymentTotals();
            OfficeGuy.Common.InitEditors($NewRow);
            OfficeGuy.Apps.Accounting.InitPayment($NewRow);
            Teva.Navigation.FocusOnFirstField($NewRow);
            return false;
        }

        static AccountingDocumentSaveID(MissingDetails, FormSelector, EnableDraft) {
            if (MissingDetails || $(".og-accounting-draft input").val() == 'False') {
                OfficeGuy.Apps.Accounting.PreSubmit(true);
                OfficeGuy.Forms.SubmitForm(FormSelector);
                return false;
            }
            var Buttons = [];
            if (EnableDraft) {
                Buttons.push($
                    (document.createElement('input')
                        .attr("type", "button")
                        .addClass("og-button-ui-action", "og-button-color-default")
                        .val(Resources.GetString("Accounting", "Save_Draft")))
                    .on("click", function () {
                        OfficeGuy.Apps.Accounting.PreSubmit(true);
                        OfficeGuy.Forms.SubmitForm(FormSelector);
                        return false;
                    }));
            }
            Buttons.push($
                (document.createElement('input')
                    .attr("type", "button")
                    .addClass("og-button-ui-action", "og-button-color-submit")
                    .val(Resources.GetString("Accounting", "Save_Books")))
                .on("click", function () {
                    OfficeGuy.Apps.Accounting.PreSubmit(false);
                    OfficeGuy.Forms.SubmitForm(FormSelector);
                    return false;
                }));
            Modals.ShowHTMLDialog({
                Title: Resources.GetString("Accounting", "Save_Title"),
                HTML: $(document.createElement('div'))
                    .append($(document.createElement('div'))
                        .html(Resources.GetString("Accounting", "Save_Description"))),
                Buttons: Buttons,
                Simple: true
            });
            return false;
        }

        static ShortCurrencyName(Currency) {
            switch (Currency) {
                case "1": return "₪";
                case "2": return "$";
                case "3": return "€";
                case "4": return "CAD";
                case "5": return "£";
                case "6": return "CHF";
                case "7": return "AUD";
                case "8": return "JPY";
                case "9": return "SEK";
                case "10": return "NOK";
                case "11": return "DKK";
                case "12": return "ZAR";
                case "13": return "JOD";
                case "14": return "LBP";
                case "15": return "EGP";
                case "975": return "BGN";
                case "203": return "CZK";
                case "348": return "HUF";
                case "985": return "zł";
                case "946": return "RON";
                case "352": return "ISK";
                case "191": return "HRK";
                case "643": return "₽";
                case "949": return "₺";
                case "986": return "BRL";
                case "156": return "CNY";
                case "344": return "HKD";
                case "360": return "IDR";
                case "356": return "INR";
                case "410": return "KRW";
                case "484": return "MXN";
                case "458": return "MYR";
                case "554": return "NZD";
                case "608": return "₱";
                case "702": return "SGD";
                case "764": return "฿";
                case "32": return "ARS";
                case "44": return "BSD";
                case "48": return "BHD";
                case "50": return "BDT";
                case "51": return "AMD";
                case "52": return "BBD";
                case "60": return "BMD";
                case "64": return "BTN";
                case "68": return "BOB";
                case "72": return "BWP";
                case "84": return "BZD";
                case "90": return "SBD";
                case "96": return "BND";
                case "104": return "MMK";
                case "108": return "BIF";
                case "116": return "KHR";
                case "132": return "CVE";
                case "136": return "KYD";
                case "144": return "LKR";
                case "152": return "CLP";
                case "170": return "COP";
                case "174": return "KMF";
                case "188": return "CRC";
                case "192": return "CUP";
                case "214": return "DOP";
                case "222": return "SVC";
                case "230": return "ETB";
                case "232": return "ERN";
                case "238": return "FKP";
                case "242": return "FJD";
                case "262": return "DJF";
                case "270": return "GMD";
                case "292": return "GIP";
                case "320": return "GTQ";
                case "324": return "GNF";
                case "328": return "GYD";
                case "332": return "HTG";
                case "340": return "HNL";
                case "364": return "IRR";
                case "368": return "IQD";
                case "388": return "JMD";
                case "398": return "KZT";
                case "404": return "KES";
                case "408": return "KPW";
                case "414": return "KWD";
                case "417": return "KGS";
                case "418": return "LAK";
                case "426": return "LSL";
                case "430": return "LRD";
                case "434": return "LYD";
                case "446": return "MOP";
                case "454": return "MWK";
                case "462": return "MVR";
                case "480": return "MUR";
                case "496": return "MNT";
                case "498": return "MDL";
                case "504": return "MAD";
                case "512": return "OMR";
                case "516": return "NAD";
                case "524": return "NPR";
                case "532": return "ANG";
                case "533": return "AWG";
                case "548": return "VUV";
                case "558": return "NIO";
                case "566": return "NGN";
                case "586": return "PKR";
                case "590": return "PAB";
                case "598": return "PGK";
                case "600": return "PYG";
                case "604": return "PEN";
                case "634": return "QAR";
                case "646": return "RWF";
                case "654": return "SHP";
                case "682": return "SAR";
                case "690": return "SCR";
                case "694": return "SLL";
                case "704": return "VND";
                case "706": return "SOS";
                case "748": return "SZL";
                case "760": return "SYP";
                case "776": return "TOP";
                case "780": return "TTD";
                case "784": return "AED";
                case "788": return "TND";
                case "800": return "UGX";
                case "807": return "MKD";
                case "834": return "TZS";
                case "858": return "UYU";
                case "860": return "UZS";
                case "882": return "WST";
                case "886": return "YER";
                case "901": return "TWD";
                case "931": return "CUC";
                case "932": return "ZWL";
                case "933": return "BYN";
                case "934": return "TMT";
                case "936": return "GHS";
                case "938": return "SDG";
                case "941": return "RSD";
                case "943": return "MZN";
                case "944": return "AZN";
                case "950": return "XAF";
                case "951": return "XCD";
                case "952": return "XOF";
                case "953": return "XPF";
                case "959": return "XAU";
                case "960": return "XDR";
                case "961": return "XAG";
                case "967": return "ZMW";
                case "968": return "SRD";
                case "969": return "MGA";
                case "971": return "AFN";
                case "972": return "TJS";
                case "973": return "AOA";
                case "976": return "CDF";
                case "977": return "BAM";
                case "980": return "UAH";
                case "981": return "GEL";
                case "990": return "CLF";
                default: return Currency;
            }
        }
        static FormatCurrency(Amount, Currency) {
            if (Amount == null)
                return "";

            return Amount.toLocaleString('he-IL', { maximumFractionDigits: 2 }) + " " + Accounting.ShortCurrencyName(Currency);
        }
        static FormatCurrencySummary(Amount, Currency) {
            if (Amount == null)
                return "";

            return "<span class=\"og-accounting-items-summarycurrency\">" + Accounting.ShortCurrencyName(Currency) + "</span> " + Number(Amount).toLocaleString('he-IL', { maximumFractionDigits: 2 });
        }

        static VATRateChanged() {
            var Instance = Teva.SelectBox.GetInstance($(".og-accounting-vatrate input:hidden"));
            $(".og-accounting-document-settingsmenu-vatrate").text(Instance.SelectedText);
            if (Instance.SelectedData != null && Instance.SelectedData.other == "1") { // Custom VAT
                var Modal = Modals.ShowInputDialog({
                    Title: "אחוז מע\"מ",
                    Message: "הזן את אחוז המע\"מ הרצוי",
                    DefaultValue: Instance.SelectedValue,
                    InputClass: "input-Decimal",
                    ConfirmText: "אישור",
                    ConfirmEvent: function (Value) {
                        Instance.SetValue(Value, Value + "% (אחר)");
                        Accounting.CalculateItemTotals();
                        Modals.Hide(Modal);
                        return true;
                    }
                });
            }
            if (Instance.SelectedData != null && Instance.SelectedData.other == "2") { // Line VAT
                //Instance.SetValue("0", "הזנה בשורה");
                $(".og-accounting-vatrate-multiple input").val("True");
                $(".documentitems").addClass("og-accounting-document-multiplevat");
                Accounting.CalculateItemTotals();
            }
            else {
                $(".og-accounting-vatrate-multiple input").val("False");
                $(".documentitems").removeClass("og-accounting-document-multiplevat");
                $(".documentitems").find(".og-accounting-items-multiplevat input").val("");
            }
            Accounting.RefreshQuantities();
        }

        static SendUsingWhatsapp(DocumentID) {
            var MobileApplication = Teva.Storage.Cookie_Get("X-OG-Mobile");
            if (MobileApplication == "Android")
                window.location.href = "/accounting/whatsappdocumentredirect/?id=" + DocumentID + "&original=" + ($("#Original").val() == 'True') + "&phone=" + Common.FormatWhatsappPhoneNumber($('#PhoneNumber').val());
            else
                window.open("/accounting/whatsappdocumentredirect/?id=" + DocumentID + "&original=" + ($("#Original").val() == 'True') + "&phone=" + Common.FormatWhatsappPhoneNumber($('#PhoneNumber').val()));
            Modals.Hide($('#Original').closest(".modal"));
            return false;
        }

        static EndsWith(String, Search) {
            if (String.length < Search.length)
                return false;
            return String.substring(String.length - Search.length) === Search;
        };

        static UpdateCustomerBankAccount(CustomerID, BankNumber, BranchNumber, AccountNumber) {
            Common.AjaxRequest({
                URL: "/accounting/updatecustomerbankaccount/",
                Data: {
                    CustomerID: CustomerID,
                    BankNumber: BankNumber,
                    BranchNumber: BranchNumber,
                    AccountNumber: AccountNumber
                }
            });
        }

        static BanksSchemaIDs: any;
        static CustomersSchemaIDs: any;
        static SuppliersSchemaIDs: any;
        static IncomeItemsSchemaIDs: any;
        static ExpenseItemsSchemaIDs: any;
        static ImportTransactionsElementInit() {
            $(".entitypickercontainer").each(function () {
                OfficeGuy.CRM.EntityPicker.RefreshAdditionalData($(this));
            });
        }
        static ImportTransactionsElementSelected($EntityPicker) {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var TransactionType = Teva.SelectBox.GetInstance(SelectBox.$Container.closest("tr").find(".og-accountinghashexport-importtransactions-transactiontype input:hidden"));
            var AccountType = SelectBox.$Container.closest("td").find(".og-accountinghashexport-importtransactions-accounttype");
            var VATRate = SelectBox.$Container.closest("tr").find(".og-accountinghashexport-importtransactions-vatrate");
            var VATSupported = false;
            if (SelectBox.SelectedData == null)
                AccountType.text("לא נבחר חשבון");
            else {
                var SchemaID = ',' + SelectBox.SelectedData.schemaid + ',';
                if ($(".og-accountinghashexport-schemaids-banks").text().indexOf(SchemaID) != -1) {
                    AccountType.text("קופה");
                }
                else if ($(".og-accountinghashexport-schemaids-customers").text().indexOf(SchemaID) != -1)
                    AccountType.text("לקוח/ה");
                else if ($(".og-accountinghashexport-schemaids-suppliers").text().indexOf(SchemaID) != -1)
                    AccountType.text("ספק/ית");
                else if ($(".og-accountinghashexport-schemaids-incomeitems").text().indexOf(SchemaID) != -1) {
                    AccountType.text("הכנסה");
                    VATSupported = true;
                    if (TransactionType.SelectedValue == "")
                        TransactionType.SetValueFromQueryMethod("1");
                }
                else if ($(".og-accountinghashexport-schemaids-expenseitems").text().indexOf(SchemaID) != -1) {
                    AccountType.text("הוצאה");
                    if (TransactionType.SelectedValue == "")
                        TransactionType.SetValueFromQueryMethod("4");
                    VATSupported = true;
                }

            }
            if (!VATSupported) {
                VATRate.find("input").val("0");
                VATRate.hide();
            }
            else
                VATRate.show();
        }
        static InitAccountsIndex() {
            $(".og-accounts-accountsindex a[data-entityid]").on("click", function (Event) {
                var $Link = $(this);
                var URL = "/accounting/updateaccountnumber/?entityid=" + $Link.data("entityid") + "&isexemptaccountnumber=" + $Link.data("isexemptaccountnumber");
                if (Teva.Navigation.IsNewWindowEvent(Event))
                    window.open(URL);
                else {
                    var $Modal = Modals.ShowHTMLGetDialog({
                        URL: URL,
                        FullURL: URL,
                        ReplaceModal: true,
                        ConvertToAjax: true,
                        ConvertToAjax_PreRenderEvent: function (ResultData) {
                            if (typeof (ResultData) != "string" && ResultData.CustomData != null && ResultData.CustomData.HTML != null) {
                                if (ResultData.Notifications != null) {
                                    setTimeout(function () {
                                        Notifications.Show(ResultData.Notifications);
                                    }, 200);
                                }
                                $Link.closest("tr").find(".og-accounts-accountsindex-accountcode").html(ResultData.CustomData.HTML == null || ResultData.CustomData.HTML.length == 0 ? "לא הוזן מפתח חשבון" : ResultData.CustomData.HTML);
                                Modals.Hide($Modal);
                                return true;
                            }
                            return false;
                        }
                    });
                }
                Event.stopPropagation();
                return false;
            });
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Apps.Accounting.Init();
});
